import { FinancialWorkspaceVisibilityPayrollDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useFinancialWorkspaceSeePayroll = () => {
  const { data, loading } = useQuery(FinancialWorkspaceVisibilityPayrollDocument)

  const canSeeFinanceWorkspacePayroll =
    data?.financialWorkspace?._policies?.payrollSee?.can ?? false

  return {
    canSeeFinanceWorkspacePayroll,
    loading,
  }
}
